import React, { useState } from "react";
import {
  Card,
  Progress,
  Typography,
  Row,
  Col,
  Avatar,
  Tag,
  Space,
} from "antd";
import { useFetchStaffProgressData } from "./hooks/getHooks";
import { formatDate, isNotEmpty } from "../../utils";
import TargetCard from "./TargetCard";

const { Title, Text } = Typography;

/* ------------------ STAFF DATA ------------------ */

const staffData = {
  sarah: {
    id: "sarah",
    name: "Sarah Johnson",
    role: "Front Desk Manager",
    initials: "SJ",
    totalPoints: 2450,
    badges: ["Top Performer", "AR Champion", "Streak 30"],
    performance: {
      paymentRequests: 45,
      arCleared: 12500,
      treatmentPlans: 32,
      noShowRate: 5.2,
    },
    targets: [
      {
        title: "Clear Outstanding AR 90+ Days",
        description: "$500 bonus for clearing $10k+ in 90+ day AR",
        progress: 7650,
        goal: 10000,
        unit: "currency",
      },
      {
        title: "Send 50 Payment Requests",
        description: "Earn the Payment Master badge",
        progress: 45,
        goal: 50,
        unit: "number",
      },
      {
        title: "Reduce No-Show Rate Below 5%",
        description: "Earn 500 points",
        progress: 5.2,
        goal: 5,
        unit: "percentage-lower-better",
      },
    ],
  },

  michael: {
    id: "michael",
    name: "Michael Chen",
    role: "Patient Coordinator",
    initials: "MC",
    totalPoints: 2180,
    badges: ["Treatment Expert", "Engagement Pro"],
    performance: {
      paymentRequests: 38,
      arCleared: 9800,
      treatmentPlans: 41,
      noShowRate: 7.1,
    },
    targets: [
      {
        title: "Send 50 Payment Requests",
        description: "Earn the Payment Master badge",
        progress: 45,
        goal: 50,
        unit: "number",
      },
      {
        title: "Reduce No-Show Rate Below 5%",
        description: "Earn 500 points",
        progress: 6.2,
        goal: 5,
        unit: "percentage-lower-better",
      },
      {
        title: "Send 40 Treatment Plans",
        description: "Featured in monthly newsletter",
        progress: 41,
        goal: 40,
        unit: "number",
      },
    ],
  },

  emily: {
    id: "emily",
    name: "Emily Rodriguez",
    role: "Billing Specialist",
    initials: "ER",
    totalPoints: 2050,
    badges: ["Billing Pro"],
    performance: {
      paymentRequests: 33,
      arCleared: 8400,
      treatmentPlans: 27,
      noShowRate: 6.4,
    },
    targets: [],
  },

  james: {
    id: "james",
    name: "James Wilson",
    role: "Patient Coordinator",
    initials: "JW",
    totalPoints: 1870,
    badges: ["Rising Star"],
    performance: {
      paymentRequests: 29,
      arCleared: 7200,
      treatmentPlans: 30,
      noShowRate: 8.1,
    },
    targets: [],
  },
};

/* ------------------ COMPONENT ------------------ */

export default function MyProgress() {
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const {staffProgressData} = useFetchStaffProgressData();

  const staff = isNotEmpty(staffProgressData) && isNotEmpty(staffProgressData.users) && staffProgressData.users.find(u => u.user_id == Number(selectedStaffId) );

  // console.log("staff", staff)
  // console.log("selectedStaffId", selectedStaffId)
  // const calculatePercent = (target) => {
  //   if (target.unit === "percentage-lower-better") {
  //     return Math.min((target.goal / target.progress) * 100, 100);
  //   }
  //   return Math.min((target.progress / target.goal) * 100, 100);
  // };

  return (
    <div style={{ marginTop: 24 }}>

      {/* ----------- STAFF SELECTOR CARDS ----------- */}

      <Card style={{marginBottom: 24}}>
        <Title level={4} style={{marginBottom: 40, fontWeight: 400}}>Select Staff Members</Title>
        <Row gutter={[16,16]} style={{ margin: 0 }}>
          {isNotEmpty(staffProgressData) && isNotEmpty(staffProgressData.users) && 
            staffProgressData.users.map((member) => {
              const isSelected = member.user_id === selectedStaffId;

              return (
                <Col span={6} key={member.user_id}>
                  <Card
                    onClick={() => setSelectedStaffId(member.user_id)}
                    hoverable
                    style={{
                      cursor: "pointer",
                      border: isSelected
                        ? "2px solid #722ed1"
                        : "1px solid #f0f0f0",
                      background: isSelected ? "#f9f0ff" : "#fff",
                    }}
                  >
                    <Row align="middle" gutter={12}>
                      <Avatar
                        style={{
                          background: isSelected ? "#722ed1" : "#d9d9d9", height: 48, width: 48, marginRight: 12
                        }}
                      >
                        {member.user_name.slice(0, 1)}
                      </Avatar>

                      <div>
                        <Text strong>{member.user_name}</Text>
                        <br />
                        {/* <Text type="secondary" style={{ fontSize: 12 }}>
                          {member.role}
                        </Text> */}
                        <br />
                        ⭐ {member.total_rewards_all_time.points}
                      </div>
                    </Row>
                  </Card>
                </Col>
              );
            })
          }
        </Row>
      </Card>

      {/* ----------- STAFF HEADER ----------- */}

      {isNotEmpty(staff) && 
        <>
          <Card style={{ marginBottom: 24, border: "1px solid #e8cfff", background: "linear-gradient(135deg, #deeafad5 0%, #e8cfffff 100%)" }}>
            <Row justify="space-between" align="middle">
              <Row align="middle" gutter={16}>
                <Avatar
                  size={64}
                  style={{ background: "#722ed1", fontSize: 22 }}
                >
                  {staff.user_name.slice(0, 1)}
                </Avatar>

                <div style={{marginLeft: 16}}>
                  <Title level={4} style={{ margin: 0 }}>
                    {staff.user_name}
                  </Title>
                  {/* <Text type="secondary">{staff.role}</Text> */}

                  {/* <div style={{ marginTop: 8 }}>
                    {staff.badges.map((badge, i) => (
                      <Tag key={i} color="purple">
                        {badge}
                      </Tag>
                    ))}
                  </div> */}
                </div>
              </Row>

              <div style={{ textAlign: "right" }}>
                <Title level={3} style={{ margin: 0 }}>
                  ⭐ {staff.total_rewards_all_time.points.toLocaleString()}
                </Title>
                <Text type="secondary">Total Points</Text>
              </div>
            </Row>
          </Card>

          {/* ----------- PERFORMANCE ----------- */}

          <Title level={4}>Your Performance This Month</Title>

          <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
            <Col span={12}>
              <Card>
                <Text type="secondary">Payment Requests Sent</Text>
                <Title level={3}>{staff.monthly_performance.payment_requests_sent}</Title>
              </Card>
            </Col>

            <Col span={12}>
              <Card>
                <Text type="secondary">AR Cleared</Text>
                <Title level={3}>
                  ${staff.monthly_performance.ar_cleared.toLocaleString()}
                </Title>
              </Card>
            </Col>

            <Col span={12}>
              <Card>
                <Text type="secondary">Treatment Plans Sent</Text>
                <Title level={3}>{staff.monthly_performance.treatment_plans_sent}</Title>
              </Card>
            </Col>

            <Col span={12}>
              <Card>
                <Text type="secondary">No-Show Rate</Text>
                <Title level={3}>{staff.monthly_performance.no_show_rate}%</Title>
              </Card>
            </Col>
          </Row>

          {/* ----------- TARGETS ----------- */}
          <Card style={{marginTop: 16}}>
            <Title level={4} style={{ marginBottom: 24, fontWeight: 400 }}>Your Active Targets</Title>

            <Space direction="vertical" size={16} style={{ width: "100%" }}>
              {isNotEmpty(staff.active_targets) && staff.active_targets.map((target, index) => {
                // const percent = calculatePercent(target);
                return (
                  <TargetCard
                    key={target.id}
                    title={target.rule_name}
                    date={`${formatDate(target.start_date)} - ${formatDate(target.end_date)}`}
                    actions={target.actions}
                    reward={`Earn ${target.reward_amount} ${target.reward_type}${target.reward_type == "points" ? '' : 's'} for achieving the target`}
                    // members={target.users_count}
                  />
                  // <Card key={index} style={{ marginBottom: 16 }}>
                  //   <Title level={5}>{target.title}</Title>
                  //   <Text type="secondary">{target.description}</Text>

                  //   <div style={{ marginTop: 16 }}>
                  //     <Row justify="space-between">
                  //       <Text>Your Progress</Text>
                  //       <Text>
                  //         {target.unit === "currency"
                  //           ? `$${target.progress.toLocaleString()} / $${target.goal.toLocaleString()}`
                  //           : `${target.progress} / ${target.goal}`}
                  //       </Text>
                  //     </Row>

                  //     <Progress percent={Math.round(percent)} />
                  //   </div>
                  // </Card>
                );
              })}
            </Space>
          </Card>
        </>
      }
    </div>
  );
}
